var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToEssilorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4527_21230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6093 27.8333L26.2587 22.4827L29.7973 18.944C30.4907 18.2507 30.2233 17.0707 29.298 16.744L12.5247 10.824C12.372 10.77 12.2207 10.7453 12.074 10.7453C11.2033 10.7453 10.5047 11.6207 10.8233 12.5253L16.7433 29.2987C16.9447 29.8687 17.4693 30.1887 18.0047 30.1887C18.3387 30.1887 18.6767 30.064 18.9433 29.7973L22.482 26.2587L27.8327 31.6093C28.094 31.87 28.4353 32 28.776 32C29.1167 32 29.4587 31.87 29.7187 31.6093L31.6093 29.7187C32.13 29.198 32.13 28.354 31.6093 27.8333ZM28.776 30.6667L22.4827 24.3733L18.0013 28.8547L12.0907 12.0847L28.8553 18.0013L24.374 22.4827L30.6667 28.776L28.776 30.6667Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H12V6H13.3333V0Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12H0V13.3333H6V12Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80457 2.86184L2.86177 3.80464L7.52816 8.47103L8.47096 7.52822L3.80457 2.86184Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4527_21230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToEssilorIcon);
export default __webpack_public_path__ + "static/media/go_to_essilor_icon.374278a6f3ccde404541ac44458bb034.svg";
export { ForwardRef as ReactComponent };